namespace TabAurous.Common {
    export interface RateIssues {
        RowNo?: number;
        AttributeType?: string;
        Remark?: string;
    }
}
